import { getSession, getProfile } from '../services/auth';

/** Sync localStorage user from Supabase profile (e.g. after admin approves upgrade). */
export async function syncUserRoleFromProfile(): Promise<boolean> {
  const session = await getSession();
  if (!session?.user) return false;

  const profile = await getProfile(session.user.id);
  if (!profile) return false;

  const userType = profile.role === 'referrer' ? 'working_professional' : 'job_seeker';

  try {
    const stored = localStorage.getItem('user');
    const existing = stored ? JSON.parse(stored) : {};
    const wasReferrer =
      existing.userType === 'working_professional' || existing.role === 'referrer';
    const isReferrer = userType === 'working_professional';

    localStorage.setItem(
      'user',
      JSON.stringify({
        ...existing,
        id: profile.id,
        full_name: profile.full_name,
        name: profile.full_name,
        primary_email: profile.primary_email,
        email: profile.primary_email,
        role: profile.role,
        userType,
        company_name: profile.company_name,
        office_email: profile.office_email,
        profile_picture: profile.profile_picture,
        credits: profile.credits,
      })
    );

    return !wasReferrer && isReferrer;
  } catch {
    return false;
  }
}

export function readStoredUserRole(): { role?: string; userType?: string } | null {
  try {
    const stored = localStorage.getItem('user');
    return stored ? JSON.parse(stored) : null;
  } catch {
    return null;
  }
}

export function isWorkingProfessionalUser(user: { role?: string; userType?: string } | null): boolean {
  if (!user) return false;
  return user.userType === 'working_professional' || user.role === 'referrer';
}

export function isAdminUser(user: { role?: string } | null): boolean {
  return user?.role === 'admin';
}
